module.exports = __webpack_public_path__ + "img/Romantikk_Bildekunsten_og_musikken6.c9cf5241.jpg";